// removed by extract-text-webpack-plugin
module.exports = {"dialog":"AppDialog__dialog-3U_cx","header":"AppDialog__header-1AyeE","close":"AppDialog__close-3OtWa","title":"AppDialog__title-3VivY","body":"AppDialog__body-1xRLU"};